import React, { memo } from 'react'
import { string, bool, func } from 'prop-types'
import Link from 'src/common/components/link'
import classNames from 'src/common/helpers/class-names'

const Title = memo(({
  className, value, href, disableLink, mix, clickHandler,
}) => {
  const blk = 'co-product'
  return (
    <h3
      className={classNames({
        className,
        blk,
        elt: 'title',
        mix,
      })}
    >
      <Link
        className={classNames({
          blk,
          elt: 'anchor',
          mods: [disableLink && 'disabled'],
        })}
        data-auto-id='linkProductTitle'
        asAnchor
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        clickHandler={clickHandler}
      >
        {value}
      </Link>
    </h3>
  )
})

Title.propTypes = {
  value: string,
  href: string,
  disableLink: bool,
  className: string,
  mix: string,
  clickHandler: func,
}

Title.defaultProps = {
  value: '',
  href: '',
  disableLink: false,
  className: '',
  mix: '',
  clickHandler() {},
}

export default Title



// WEBPACK FOOTER //
// ./shared/interim/product/title/index.js